import { Navigate, RouteObject, useRoutes } from "react-router-dom";
import { APP_ROUTES } from "@/routers/routes";
import AuthLayout from "@/layouts/auth-layout";
import RequireAnonymous from "@/routers/RequireAnonymous";
import Login from "./login";
import Verify from "./verify";
import AccessDenied from "./access-denied";

const configAuthRoutes: RouteObject[] = [
  {
    path: "*",
    element: (
      <RequireAnonymous>
        <AuthLayout />
      </RequireAnonymous>
    ),
    children: [
      {
        index: true,
        element: <Verify />,
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "access-denied",
        element: <AccessDenied />,
      },
      {
        path: "*",
        element: <Navigate to={APP_ROUTES.LOGIN.to} replace />,
      },
    ],
  },
];

function AuthPage() {
  return useRoutes(configAuthRoutes);
}

export default AuthPage;
